module.exports = __webpack_public_path__ + "img/feeling.59c1f8de.svg";